<template>
  <div
    v-if="!isBrokenChat"
    :class="[$style.container, { [$style.containerActive]: isActive, [$style.containerSearched]: isSearchInThisChat }]"
  >
    <template v-if="!chat.provider && chat.provider !== $options.messengerProviders.matrix">
      <div :class="$style.avatarWrap">
        <div v-if="chat.typeName === 'saved-messages'" :class="$style.savedMessagesAvatar">
          <BaseIcon name="star" />
        </div>
        <div :class="$style.providerIcon">
          <img :class="$style.providerIconImg" :src="$options.providersIcons['default']" alt="" />
        </div>
        <ChatAvatar v-bind="{ chat, receiver, isShowOnline: true }" />
      </div>
      <div :class="$style.info">
        <div :class="$style.topInfo">
          <div :class="$style.title">{{ title }}</div>
          <div v-if="!isSearchInThisChat" :class="$style.date">
            {{ time }}
            <svg
              v-show="chat.typeName === 'group'"
              style="color: #00b764"
              :class="$style.groupIcon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#000000"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
              />
            </svg>
          </div>
        </div>
        <div :class="[$style.message, { [$style.messageUnreaded]: notificationCounts }]">
          <template v-if="isSearchInThisChat">
            {{ $t('chat.searchInChat') }}
            <BaseIcon custom name="close" @click="$emit('clear-search')" :class="$style.clear" />
          </template>
          <template v-else>
            <template v-if="chat.isTyping">{{ $t('chat.typing') }}</template>
            <template v-else>
              <span v-if="messageAuthor && displayMessage.type" :class="$style.messageColored"
                >{{ messageAuthor }}:</span
              >
              {{ messageText }}
            </template>
          </template>
          <div
            v-if="notificationCounts"
            :class="[$style.badgeUnreadMessages, { [$style.badgeUnreadMessagesEmpty]: notificationCounts === true }]"
          >
            {{ notificationCounts === true ? '' : notificationCounts }}
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="$style.avatarWrap">
        <div v-if="chat.subProvider" :class="$style.providerIcon">
          <img :class="$style.providerIconImg" :src="$options.providersIcons[chat.subProvider]" alt="" />
        </div>
        <ChatAvatar v-bind="{ chat, chatFullVersion, isShowOnline: true }" />
      </div>
      <div :class="$style.info">
        <div :class="$style.topInfo">
          <div :class="$style.title">{{ formattedUserName(chat.name) }}</div>
          <div v-if="!isSearchInThisChat" :class="$style.date">
            {{ timeMatrix }}
            <svg
              v-show="chat.memberCount === 'group' && chat.memberCount > 2"
              :class="$style.groupIcon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="#000000"
            >
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
              />
            </svg>
          </div>
        </div>
        <div :class="[$style.message, { [$style.messageUnreaded]: !notificationCounts }]">
          <template v-if="chat.typingUsers.length">
            <span v-for="user in chat.typingUsers" :key="user">
              {{ formattedUserName(user) }} {{ $t('chat.typing') }}
            </span>
          </template>
          <template v-else>
            <div
              v-if="
                chat.selfMembership === $options.selfMembershipTypes.join ||
                chat.selfMembership === $options.selfMembershipTypes.leave
              "
            >
              <template v-if="lastMessageFromMatrix && chat.selfMembership !== $options.selfMembershipTypes.leave">
                <template v-if="lastMessageFromMatrix.type === $options.eventTypes.redaction">
                  <div style="display: flex; justify-content: flex-start; align-items: center">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      color="#888"
                      data-icon="trash-alt"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      class="svg-inline--fa fa-trash-alt fa-w-14"
                    >
                      <path
                        fill="currentColor"
                        d="M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
                        class=""
                      ></path>
                    </svg>
                    <span style="margin-left: 4px; overflow: hidden">
                      {{ $t('messageDeletedBy') }}
                      <b>{{
                        (lastMessageFromMatrix.redacted_because &&
                          message.redacted_because.sender.split(':')[0].slice(1)) ||
                        lastMessageFromMatrix.sender.split(':')[0].slice(1)
                      }}</b>
                    </span>
                  </div>
                </template>
                <template v-else-if="lastMessageFromMatrix.type === $options.eventTypes.message">
                  <p
                    style="max-width: 90%; overflow-x: hidden; overflow-y: hidden; text-overflow: ellipsis"
                    v-html="formattedMessage"
                  ></p>
                </template>
                <template v-else-if="lastMessageFromMatrix.type === $options.eventTypes.name">
                  {{ $t('changeChatName') }} <b>{{ message.content.name }}</b>
                </template>
                <template v-else-if="lastMessageFromMatrix.type === $options.eventTypes.avatar">
                  <span v-if="messageAuthorMatrix" :class="$style.messageColored">{{ messageAuthorMatrix }}:</span>
                  {{ $t('changeChatAvatar') }}
                </template>
                <template v-if="lastMessageFromMatrix.type === $options.eventTypes.member">
                  <template
                    v-if="
                      lastMessageFromMatrix.content.membership === $options.selfMembershipTypes.invite &&
                      lastMessageFromMatrix.content.displayname
                    "
                  >
                    {{ $t('invite') }}
                    <avatar
                      :size="20"
                      style="margin-left: 7px"
                      :user="{
                        firstName: formattedUserName(lastMessageFromMatrix.content.displayname).toUpperCase(),
                        avatarLink: createLinkImage(lastMessageFromMatrix.content.avatar_url)
                      }"
                    />
                    <b style="margin: 0 5px">{{ formattedUserName(message.content.displayname) }}</b>
                  </template>
                  <template v-if="lastMessageFromMatrix.content.membership === $options.selfMembershipTypes.leave">
                    {{ $t('kick') }}
                    <b>{{ lastMessageFromMatrix.state_key.slice(1).split(':')[0] }}</b>
                  </template>
                  <template v-if="lastMessageFromMatrix.content.membership === $options.selfMembershipTypes.join">
                    {{ $t('joinChat') }}
                  </template>
                </template>
              </template>
              <template v-else>
                <p :class="$style.inviteLabel">
                  {{ $t('inactiveChat') }}
                </p>
              </template>
            </div>
            <p :class="$style.inviteLabel" v-else>
              {{ $t('invite') }}
            </p>
          </template>
          <div
            v-if="notificationCounts"
            :class="[$style.badgeUnreadMessages, { [$style.badgeUnreadMessagesEmpty]: notificationCounts === true }]"
          >
            {{ notificationCounts === true ? '' : notificationCounts }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Avatar from '@/components/Avatar'
import ChatAvatar from './ChatAvatar'
import { mapGetters } from 'vuex'
import moment from 'moment'
import { TYPE_CODE, REASON_NAME } from '@/models/Message'
import { eventTypes, messengerProviders, selfMembershipTypes } from '@/helpers/variables'
import { getUserFullName, formattedUserName, createLinkImage, getCountUnreadMessages } from '@/helpers'
import { msgTypes, EMOJI } from '@/helpers/variables/index'
import { getUserDisplayName } from '@/utils/helpers'

const providersIcons = {
  whatsapp: require('@/assets/icons/png/whatsapp-ico.png'),
  telegram: require('@/assets/icons/png/telegram-ico.png'),
  default: require('@/assets/icons/png/hola-ico.png')
}

export default {
  providersIcons,
  messengerProviders,
  selfMembershipTypes,
  eventTypes,
  name: 'chat-list-item',
  components: {
    ChatAvatar,
    Avatar
  },
  props: {
    chat: {
      type: Object,
      required: true
    },
    isActive: Boolean,
    message: Object,
    isSearchInThisChat: Boolean
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      findUser: 'entities/users/find',
      roomMembers: 'matrix/roomMembers',
      messagesByChat: 'entities/messages/listByChatId'
    }),
    notificationCounts () {
      const result = getCountUnreadMessages(this.chat, this.user)
      return typeof result === 'number' ? result : result ? true : 0
    },
    user () {
      return this.$store.state.auth.user
    },
    chatFullVersion () {
      if (!this.chat.provider) return null
      return window.matrixSDK.getRoom(this.chat.id)
    },
    receiver () {
      if (this.chat.typeName !== 'one-to-one') return null
      return this.chat.participantsUsers.find(user => {
        if (!user) return
        return user.userId !== this.user.id
      })
    },
    isBrokenChat () {
      if (!this.chat) return
      return this.chat.typeName === 'one-to-one' && !this.receiver
    },
    title () {
      if (this.chat.typeName === 'one-to-one' && this.receiver) {
        return this.receiver.displayName
      }
      if (this.chat.typeName === 'saved-messages') {
        return this.$t('chat.savedMessages')
      }
      return this.chat.name
    },
    chatMessages () {
      return this.messagesByChat(this.chat.id)
    },
    displayMessage () {
      if (this.message) return this.message
      const messages = this.chatMessages
      const lastMessage = messages.length ? messages[messages.length - 1] : this.chat.message
      return lastMessage
    },
    messageText () {
      let message
      if (this.displayMessage && this.displayMessage.type === TYPE_CODE.forward) {
        message = { ...this.displayMessage.payload }
        if (this.displayMessage.attachment) {
          message.attachment = this.displayMessage.attachment
        }
      } else {
        message = this.displayMessage
      }
      return this.getLastMessageText(message)
    },
    messageAuthor () {
      if (!this.displayMessage || !this.displayMessage.sender) return ''
      const lastMsgUser = this.displayMessage.sender
      if (this.chat.typeName === 'saved-messages') return ''
      const isMy = lastMsgUser.userId === this.user.id
      return isMy ? this.$t('chat.you') : getUserDisplayName(lastMsgUser).split(' ')[0]
    },
    messageAuthorMatrix () {
      const senderId = this.lastMessageFromMatrix?.sender
      if (!senderId) return ''
      const isMy = senderId === this.user.id
      const sender = this.roomMembers.find(member => member.id === senderId)
      if (!sender) return ''
      return isMy ? this.$t('chat.you') : sender.display_name.split(' ')[0]
    },
    time () {
      if (!this.displayMessage) return
      return this.formattedTimeReceiveLastMessage(this.displayMessage.created)
    },
    timeMatrix () {
      if (!this.chat) return
      if (!this.chat.lastMessages.length) return
      return this.formattedTimeReceiveLastMessage(this.chat.lastMessages[0].created)
    },
    lastMessageFromMatrix () {
      return this.chat.lastMessages[0]
    },
    formattedMessage () {
      const msgtype = this.lastMessageFromMatrix.content.msgtype
      if (msgtype === msgTypes.location) {
        return `${EMOJI.location} ${this.$t('messageType.location')}`
      }
      if (this.lastMessageFromMatrix.content.new_body && !this.showOriginal) {
        return this.lastMessageFromMatrix.content.new_body
      }
      if (this.lastMessageFromMatrix.content.formatted_body && this.lastMessageFromMatrix.content['m.relates_to']) {
        return this.lastMessageFromMatrix.content.formatted_body.split('</mx-reply>')[1]
      }
      if (this.lastMessageFromMatrix.content.formatted_body) {
        return this.lastMessageFromMatrix.content.formatted_body
      }
      const body = this.lastMessageFromMatrix.content.body
      const msgTypesMath = {
        [msgTypes.audio]: `${EMOJI.voice} ${this.$t('messageType.voice')}`,
        [msgTypes.file]: `${EMOJI.file} ${body}`,
        [msgTypes.gif]: `${EMOJI.giphy} ${this.$t('messageType.giphy')}`,
        [msgTypes.image]: `${EMOJI.image} ${this.$t('messageType.image')}`,
        [msgTypes.sticker]: `${EMOJI.sticker} ${this.$t('messageType.sticker')}`,
        [msgTypes.video]: `${EMOJI.video} ${this.$t('messageType.video')}`
      }
      return msgTypesMath[msgtype] || body
    }
  },
  methods: {
    createLinkImage,
    formattedUserName,
    formattedTimeReceiveLastMessage (messageReceiveDate) {
      const format = 'YYYY-MM-DD hh:mm A'
      const receivedMessageDate = moment(messageReceiveDate).format(format)
      const endDateToday = moment().endOf('day').format(format)
      const endDateCurrentYear = moment().endOf('day').format(format)
      const isReceiveMessageAfterToday = moment(endDateToday).isAfter(receivedMessageDate, 'day')
      const isReceiveMessageAfterCurrentYear = moment(endDateCurrentYear).isAfter(receivedMessageDate, 'year')

      const utcToMyTimezone = moment.utc(messageReceiveDate).local()

      return isReceiveMessageAfterCurrentYear
        ? moment(utcToMyTimezone).format('MM/DD/YYYY')
        : isReceiveMessageAfterToday
          ? moment(utcToMyTimezone).format('DD MMM')
          : moment(utcToMyTimezone).format('hh:mm A')
    },
    getServiceMessageByReason (message) {
      if (!message.payload) return ''
      const reason = REASON_NAME[message.payload.reason]
      if (reason) {
        const fullName = getUserFullName(message.sender)
        return this.$t(`chat.serviceMessage.${reason}`, { fullName })
      }
      return JSON.stringify(message.payload)
    },
    getLastMessageText (message) {
      if (!message) return this.$t('chat.listNoMessages')
      if (message.translatedMessage) {
        return message.translatedMessage.targetText
      }
      const msgTypesMath = {
        [TYPE_CODE.attachment]: `${EMOJI.attachment} ${this.$t('messageType.attachment')}`,
        [TYPE_CODE.call]: `${EMOJI.call} ${this.$t('messageType.call')}`,
        [TYPE_CODE.contact]: `${EMOJI.contact} ${this.$t('messageType.contact')}`,
        [TYPE_CODE.giphy]: `${EMOJI.giphy} ${this.$t('messageType.giphy')}`,
        [TYPE_CODE.photo]: `${EMOJI.image} ${this.$t('messageType.image')}`,
        [TYPE_CODE.service]: this.getServiceMessageByReason(message),
        [TYPE_CODE.video]: `${EMOJI.video} ${this.$t('messageType.video')}`,
        [TYPE_CODE.voice]: `${EMOJI.voice} ${this.$t('messageType.voice')}`
      }
      return msgTypesMath[message.type] || message.payload
    }
  }
}
</script>

<style module lang="scss">
.providerIcon {
  display: block;
}
.badgeUnreadMessages {
  background: $text-error;
  height: 16px;
  border-radius: 10em;
  padding: 0 5px;
  color: #fff;
  min-width: 16px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-weight: 500;
  &Empty {
    height: 10px;
    padding: 0px;
    min-width: 10px;
  }
}
.inviteLabel {
  color: $text-error;
  padding: 2px 5px;
  border: 1px solid $text-error;
  display: inline-block;
  border-radius: 10em;
}
.providerIconImg {
  display: block;
  width: 24px;
  height: 24px;
  position: absolute;
  z-index: 2;
  left: -12px;
  top: 50%;
  transform: translateY(-50%);
  background: #fff;
  padding: 1px;
  border-radius: 50%;
}
.container {
  display: flex;
  height: 76px;
  // padding-left: 14px;
  padding: 10px 10px 10px 14px;

  &:not(&Searched) {
    cursor: pointer;
  }
  &:hover:not(&Active):not(&Searched) {
    background-color: rgba($main-bg-darkest, 0.1);
  }
  &Active {
    background-color: $main-bg-darkest;
    color: $text-lightest;
    // * {
    //   color: $text-lightest;
    // }
  }
}
.info {
  padding-top: 6px;
  padding-left: 10px;
  flex-basis: 0;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
}
.topInfo {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.title,
.message {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  position: relative;
  &Unreaded {
    padding-right: 20px;
  }
}
.title {
  font-size: 16px;
  font-weight: 500;
  padding-right: 4px;
}
.message {
  color: $text-mid-dark;
  padding-top: 4px;
  &Colored {
    color: $text-colored;
  }
}
.avatarWrap {
  display: flex;
  align-items: center;
  flex-grow: 0;
  position: relative;
}
.savedMessagesAvatar {
  width: 56px;
  height: 56px;
  border-radius: 100%;
  background-color: $main-bg-colored;
  color: $text-lightest;
  font-size: 25px;
  text-align: center;
  line-height: 56px;
}
.date {
  color: $text-light;
  font-size: 12px;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    margin-left: 3px;
  }
}

.clear {
  cursor: pointer;
  width: 14px;
  position: absolute;
  right: 8px;
  top: 18px;
  color: $text-dark;
}
.groupIcon {
  width: 18px;
  height: 18px;
  margin-bottom: 1px;
}
</style>
